/* eslint-disable */
export default {
  start: '進行快速導覽',
  skip: '略過',
  next: '下一步',
  finish: '結束',
} as const;

// @key: @#@"start"@#@ @source: @#@"Take a quick tour"@#@
// @key: @#@"skip"@#@ @source: @#@"Skip"@#@
// @key: @#@"next"@#@ @source: @#@"Next"@#@
// @key: @#@"finish"@#@ @source: @#@"Finish"@#@
